import Quill from 'quill';

const BlockEmbedBlot = Quill.import('blots/block/embed');

class DividerBlot extends BlockEmbedBlot {}
DividerBlot.blotName = 'divider';
DividerBlot.tagName = 'hr';

export default DividerBlot;
